module.exports = __webpack_public_path__ + "img/198.66c519df.jpg";